import {PageTypeGroup} from "./page-type-group.model";
import {Event} from "./event.model";

export class MapEventsAndArticles {
  events?: Event[];
  pageTypeGroups?: PageTypeGroup[];
}
